import { getRandomId } from 'framework-ui-components/Components/Utils/baseComponentHelper';
import { WebRequest } from 'framework-ui-components';
import { PluginMessageTypes } from './constants';
import MessagesPlugin from './messages';
import Log from '../utils/log';

// timeout massimo di chiamata verso parent
const TimeoutMaxMs = 5000;

const FORWARD_GET = 'GET';

// elenco delle sotto-tipologie gestite come call forward
const CallForwardTypes = [
  FORWARD_GET,
];

/**
 * Promise per effettuare una chiamata in promise del parent da una applicazione
 * caricata in un iframe
 * @param {string} type - tipologia della chiamata (GET, POST)
 * @param {string} uri - identificativo della chiamata
 * @param {object} params - [opzionale] parametri eventuali di chiamata
 * @param {number} timeoutLimit - [opzionale - default 5000] limite di attesa per
 *  una eventuale risposta (ms)
 */
const callParent = (
  type, uri, params, timeoutLimit = TimeoutMaxMs,
) => new Promise((resolve, reject) => {
  const callId = getRandomId();
  let timeoutID;
  const checkResponse = (message) => {
    if (message.type === PluginMessageTypes.CALL_FORWARD_RESPONSE
      && message.payload && message.payload.callId === callId) {
      clearTimeout(timeoutID);
      MessagesPlugin.unsubscribe(checkResponse);
      resolve(message.payload.response);
    }
  };
  MessagesPlugin.subscribe(checkResponse);
  MessagesPlugin.postMessageToParent(
    PluginMessageTypes.CALL_FORWARD,
    {
      type,
      callId,
      uri,
      params,
    },
  );
  timeoutID = setTimeout(() => {
    MessagesPlugin.unsubscribe(checkResponse);
    reject(new Error('timed out!'));
  }, timeoutLimit);
});

/**
 * Promise per effettuare una chiamata in promise dell'applicazione
 * da parte del parent
 * @param {string} type - tipologia della chiamata (GET, POST)
 * @param {string} uri - identificativo della chiamata
 * @param {object} params - [opzionale] parametri eventuali di chiamata
 * @param {string} idDestination - [opzionale] eventuale identificativo del destinatari
 * @param {number} timeoutLimit - [opzionale - default 5000] limite di attesa per
 *  una eventuale risposta (ms)
 */
const callChild = (
  type, uri, params, idDestination = null, timeoutLimit = TimeoutMaxMs,
) => new Promise((resolve, reject) => {
  const callId = getRandomId();
  let timeoutID;
  const checkResponse = (message) => {
    if (message.type === PluginMessageTypes.CALL_FORWARD_RESPONSE
      && message.payload && message.payload.callId === callId) {
      clearTimeout(timeoutID);
      MessagesPlugin.unsubscribe(checkResponse);
      resolve(message.payload.response);
    }
  };
  MessagesPlugin.subscribe(checkResponse);
  MessagesPlugin.postMessageToChilds(
    PluginMessageTypes.CALL_FORWARD,
    {
      type,
      callId,
      uri,
      params,
    },
    idDestination,
  );
  timeoutID = setTimeout(() => {
    MessagesPlugin.unsubscribe(checkResponse);
    reject(new Error('timed out!'));
  }, timeoutLimit);
});

const callAndResponse = (type, url, params, callId, forwardFunc) => {
  if (type === FORWARD_GET) {
    WebRequest.get(url, params).then((response) => {
      forwardFunc(
        PluginMessageTypes.CALL_FORWARD_RESPONSE,
        { callId, response },
      );
    });
  } else {
    Log.warn('Tipo chiamata forward non riconosciuta');
  }
};

const callAndResponseToChild = (type, url, params, callId) => {
  callAndResponse(type, url, params, callId, MessagesPlugin.postMessageToChilds);
};

const callAndResponseToParent = (type, url, params, callId) => {
  callAndResponse(type, url, params, callId, MessagesPlugin.postMessageToParent);
};

export {
  CallForwardTypes,
  callParent,
  callChild,
  callAndResponseToChild,
  callAndResponseToParent,
};
